export default {
  legalText: {
    id: 'review_form_legal_text',
    defaultMessage:
      'By submitting, you agree to our {privacy, html} and acknowledge that your first name and review will be published. For more info, see our {otherTerms, html}',
  },
  privacyLink: {
    id: 'review_form_privacy_link',
    defaultMessage: 'privacy policy',
  },
  otherTermsLink: {
    id: 'review_form_other_terms_link',
    defaultMessage: 'Other legal information notice',
  },
} as const
